// src/context/MessageContext.js
import React, { createContext, useContext, useReducer } from "react";

const MessageContext = createContext();

const initialState = {};

function messageReducer(state, action) {
  switch (action.type) {
    case "SET_MESSAGES":
      return { ...state, [action.topicId]: action.messages };
    case "APPEND_MESSAGE": {
      const currentMessages = state[action.topicId] || [];
      return {
        ...state,
        [action.topicId]: [action.message, ...currentMessages],
      };
    }
    default:
      return state;
  }
}

export const MessageProvider = ({ children }) => {
  const [state, dispatch] = useReducer(messageReducer, initialState);
  return (
    <MessageContext.Provider value={{ state, dispatch }}>
      {children}
    </MessageContext.Provider>
  );
};

export const useMessageContext = () => useContext(MessageContext);
